export default __webpack_public_path__ + "static/media/international.00fecb80.webp";